module.exports = __webpack_public_path__ + "img/indodigi-journey.b0d5d676.webp";